export type RibbonToastSeverity = 'error' | 'warning' | 'success' | 'info';

/**
 * Theme palette path for the severity ribbon / accents.
 */
export function getRibbonToastSeverityColor(severity: RibbonToastSeverity): string {
  switch (severity) {
    case 'error':
      return 'error.main';
    case 'warning':
      return 'warning.main';
    case 'success':
      return 'success.main';
    case 'info':
      return 'info.main';
  }
}

/**
 * Whether a toast stays open until dismissed (error/warning).
 * Also selects contained button vs clickable Paper + cue for the primary action.
 */
export function isRibbonToastSticky(severity: RibbonToastSeverity): boolean {
  return severity === 'error' || severity === 'warning';
}
